import { styled } from "@/root/stitches.config";
import React from "react";

import { Text } from "@/components/text";

import TagBlueImage from "@/assets/activities/tag-blue.svg";
import TagOrangeImage from "@/assets/activities/tag-orange.svg";

const Title = styled(Text, {
    fontSize: "2.5em",
    "@mobile": {
        fontSize: "8vw",
    },
});

const TagIcon = styled("img", {
    height: "1.5rem",
    width: "auto",
});

export default function HeaderSection({
    name,
    type,
    isActivity,
    closedDate,
}) {
    const date = new Date(closedDate);

    const option = {
        day: "numeric",
        month: "short",
        year: "numeric",
    };

    const formattedDate = date.toLocaleDateString("en-GB", option);

    return (
        <section
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.75rem",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "0.75rem",
                }}
            >
                <Title css={{ color: "$dark", overflow: "hidden" }}>
                    {name}
                </Title>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                    }}
                >
                    <TagIcon
                        src={isActivity ? TagBlueImage : TagOrangeImage}
                        alt="Tag"
                    />

                    <Text
                        css={{
                            color: isActivity ? "$dark" : "$secondary",
                            fontSize: "1.25rem",
                            "@mobile": {
                                fontSize: "0.95rem",
                            },
                        }}
                    >
                        {type}
                    </Text>
                </div>
            </div>

            <Text
                css={{
                    color: "$dark",
                    display: "flex",
                    flexDirection: "column",
                    lineHeight: "1.3",
                    fontSize: "1.25rem",
                }}
            >
                <span>Closed at</span>
                <span>{formattedDate}</span>
            </Text>
        </section>
    );
}